module.exports = __webpack_public_path__ + "static/media/contacts.e79da24b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/cases/influencers/assets/contacts.png
// module id = 300
// module chunks = 0